import React from 'react';
import { CandidateCard, type CandidateCardProps } from './CandidateCard';
import { useTranslations } from '@vocab/react';
import translations_tal from '../../.vocab';
import { Box, Stack, Text, Tiles } from 'braid-design-system';

interface CandidateInformationProps {
  candidateCards: CandidateCardProps[];
}

export const CandidateInformation = ({
  candidateCards,
}: CandidateInformationProps) => {
  const { t: t_tal } = useTranslations(translations_tal);
  return (
    <Box>
      <Stack space="gutter">
        <Text size="large" weight="strong">
          {t_tal('About these candidates')}
        </Text>

        <Tiles columns={{ mobile: 1, tablet: 2 }} space="medium">
          {candidateCards.map((card, index) => (
            <CandidateCard {...card} key={index} />
          ))}
        </Tiles>
      </Stack>
    </Box>
  );
};
